export class Defaut {
    static jsonMap = {
        id: 'id',
        code: 'code',
        libelle: 'libelle'
    };

    id: number;
    code: string;
    libelle: string;
}
